// https://rive-app.github.io/rive-react/?path=/docs/react-runtime-overview--rive-component
import RiveComponent from '@rive-app/react-canvas'; // { useRive }
import { appPath } from '@web3/base-utils';

import styles from './style.module.scss';

export function DrawAnimation() {
  return (
    <div className={styles['draw-wrap']}>
      <RiveComponent
        src={`${appPath}/riv/smaill_box.riv`}
        className={`${styles['base-canvas-size']} ${styles['draw-content']}`}
      />
    </div>
  );
}
